import { forwardRef } from "react";

import { BaseFormCounterButton, BaseFormCounterButtonProps } from "./BaseFormCounterButton";

import { mergeSx } from "@/forms-design-system/helpers";
import { Minus } from "@/icons/outlined";

type FormDecrementButtonProps = Omit<BaseFormCounterButtonProps, "icon" | "blowupPosition">;

export const FormDecrementButton = forwardRef<HTMLButtonElement, FormDecrementButtonProps>(({ sx, ...rest }, ref) => {
  const styles = mergeSx(
    {
      "&:hover .form-counter-button-rotate-icon": {
        transform: "rotate(-180deg)",
      },
    },
    sx
  );

  return (
    <BaseFormCounterButton
      icon={<Minus />}
      rippleOrigin="bottom-left"
      sx={styles}
      ref={ref}
      data-test="themed-decrement-button"
      {...rest}
    />
  );
});
FormDecrementButton.displayName = "FormDecrementButton";
